import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", {
    class: "assign-list",
    style: _normalizeStyle({ height: _ctx.height ? _ctx.height + 'px' : 'auto' })
  }, [
    _createVNode(_component_a_table, {
      dataSource: _ctx.data,
      columns: _ctx.columns,
      bordered: "",
      pagination: false,
      scroll: { x: 880 }
    }, null, 8, ["dataSource", "columns"])
  ], 4))
}